// Events the site sends to whatever statistics it was given: a search, the start of an episode, an episode watched to the end.
// Nothing here is personal: the drama's id and the episode number. Before the visitor has accepted (when the site asks first),
// or when no statistics were set up, every call does nothing.
let via = null;
let plausible = false;

export function setMode(mode, withPlausible = false) {
  if (mode) via = mode;
  if (withPlausible) plausible = true;
}

export function track(name, params = {}) {
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
    if (via === 'gtm' && window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: name, ...params });
    }
    if (plausible && typeof window.plausible === 'function') {
      window.plausible(name, { props: params });
    }
  } catch {
    // statistics must never break the page
  }
}
